var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 1.66699C5.40286 1.66699 1.66602 5.40383 1.66602 10.0003C1.66602 14.5968 5.40286 18.3337 9.99935 18.3337C14.5958 18.3337 18.3327 14.5968 18.3327 10.0003C18.3327 5.40383 14.5958 1.66699 9.99935 1.66699ZM14.5783 13.088C14.4204 13.474 14.1397 13.86 13.9643 14.0354C12.9643 15.0354 10.2801 14.1407 8.06952 11.9301C5.859 9.71962 4.96426 7.05296 5.96426 6.03541C6.1397 5.85997 6.54321 5.57927 6.91163 5.42138C7.19233 5.29857 7.52566 5.38629 7.71865 5.6319L8.82391 7.03541C9.05198 7.31611 9.01689 7.73717 8.73619 7.98278C8.45549 8.2284 8.26251 8.40383 8.20987 8.45647C7.78882 8.87752 8.40286 9.77225 9.33268 10.7021C10.2625 11.6319 11.1397 12.2635 11.5783 11.8249C11.6309 11.7723 11.8064 11.5793 12.052 11.2986C12.2976 11.0179 12.7011 10.9828 12.9993 11.2109L14.4029 12.3161C14.6309 12.4565 14.7011 12.7898 14.5783 13.088Z",
    fill: "#747B82"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.634861e1.svg";
export { ForwardRef as ReactComponent };